'use client';

import { c as _c } from "react/compiler-runtime";
import { setCookie } from 'cookies-next/client';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { type ChangeEvent, type MouseEvent, useRef, useState } from 'react';
import { analyticEventSentListingMessage } from '@/features/analytic/enteties/analytic';
import createMessage from '@/features/listing/requests/create-message';
import { type ListingDataView, type ListingWithUser } from '@/features/listing/types/listing-types';
import { loggedUserAtom } from '@/features/user/atoms/logged-user-atom';
import { useRouter } from '@/i18n/routing';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';
import { SECONDS } from '@/shared/constants/time-constants';
import { type MessageSentSource } from '@/shared/types/report-types';
import Button from '@/ui/button/button';
import styles from './listing-message.module.scss';
interface ListingMessageProps {
  listing: ListingWithUser;
  onSent?: () => void;
  view?: ListingDataView;
  messageSrc?: MessageSentSource;
}
export default function ListingMessage(props) {
  const $ = _c(33);
  const {
    listing,
    messageSrc,
    onSent,
    view: t0
  } = props;
  const view = t0 === undefined ? "isCard" : t0;
  const router = useRouter();
  const listingMessageModalTranslations = useTranslations("listing.message");
  const loggedUser = useAtomValue(loggedUserAtom);
  const inputRef = useRef(null);
  const [message, setMessage] = useState("");
  const [isSuccessSent, setIsSuccessSent] = useState(false);
  const [isSending, setIsSending] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      setMessage(event.target.value);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleMessageChange = t1;
  let t2;
  if ($[1] !== listing || $[2] !== loggedUser || $[3] !== router) {
    t2 = () => {
      if (!loggedUser) {
        setCookie("authData", JSON.stringify({
          token: "send-message",
          userName: listing.user.firstName
        }), {
          maxAge: SECONDS.HOUR,
          path: "/"
        });
        router.push(ROUTER_LINKS.phoneAuth);
      } else {
        if (!loggedUser.isVerified) {
          router.push(ROUTER_LINKS.accountValidation);
        }
      }
    };
    $[1] = listing;
    $[2] = loggedUser;
    $[3] = router;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleTextboxClick = t2;
  let t3;
  if ($[5] !== listing || $[6] !== loggedUser || $[7] !== message || $[8] !== messageSrc || $[9] !== onSent || $[10] !== router) {
    t3 = event_0 => {
      event_0.preventDefault();
      event_0.stopPropagation();
      if (!loggedUser) {
        setCookie("authData", JSON.stringify({
          token: "send-message",
          userName: listing.user.firstName
        }), {
          maxAge: SECONDS.HOUR,
          path: "/"
        });
        router.push(ROUTER_LINKS.phoneAuth);
        return;
      }
      if (!loggedUser.isVerified) {
        router.push(ROUTER_LINKS.accountValidation);
        return;
      }
      setIsSending(true);
      createMessage({
        listingId: listing.id,
        message,
        messageSrc,
        recipientId: listing.user.id
      }).then(() => {
        setMessage("");
        setIsSuccessSent(true);
        analyticEventSentListingMessage();
        if (onSent) {
          onSent();
        }
      }).catch(_temp).finally(() => {
        setIsSending(false);
      });
    };
    $[5] = listing;
    $[6] = loggedUser;
    $[7] = message;
    $[8] = messageSrc;
    $[9] = onSent;
    $[10] = router;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleMessageSend = t3;
  let t4;
  if ($[12] !== listing || $[13] !== listingMessageModalTranslations || $[14] !== view) {
    t4 = view === "isCard" ? listingMessageModalTranslations("write-message") : `${listingMessageModalTranslations("write-message-to")} ${listing.user.firstName}`;
    $[12] = listing;
    $[13] = listingMessageModalTranslations;
    $[14] = view;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const messagePlaceholder = t4;
  const t5 = `${messagePlaceholder}...`;
  let t6;
  if ($[16] !== handleTextboxClick || $[17] !== message || $[18] !== t5) {
    t6 = <textarea ref={inputRef} placeholder={t5} className={styles.listingMessage_message} value={message} onChange={handleMessageChange} onClick={handleTextboxClick} />;
    $[16] = handleTextboxClick;
    $[17] = message;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== listingMessageModalTranslations) {
    t7 = listingMessageModalTranslations("sent");
    $[20] = listingMessageModalTranslations;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== listingMessageModalTranslations) {
    t8 = listingMessageModalTranslations("send-message");
    $[22] = listingMessageModalTranslations;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== handleMessageSend || $[25] !== isSending || $[26] !== isSuccessSent || $[27] !== t7 || $[28] !== t8) {
    t9 = <div className={styles.listingMessage_sendMessage}><Button element="button" size="md" fontSize="xs" onClick={handleMessageSend} fullWidth={true} isLoading={isSending} isSuccess={isSuccessSent} successMessage={t7}>{t8}</Button></div>;
    $[24] = handleMessageSend;
    $[25] = isSending;
    $[26] = isSuccessSent;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t6 || $[31] !== t9) {
    t10 = <div className={styles.listingMessage}>{t6}{t9}</div>;
    $[30] = t6;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
}
function _temp() {
  return null;
}